import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightLeft, PhoneCall, CheckCircle2, ChevronRight, BellRing } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { companyLabel, GRUPO, fmtDT } from './c360Shared';
import { PendBadge, Countdown, isManager } from '../pendencias/pendShared';
import { AlertComercialDialog } from '../pendencias/AlertComercialDialog';

const OPEN = ['enviado', 'lido', 'em_atraso', 'pendente_resolucao'];

const PendInfo = ({ p, i }) => (
  <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-slate-600" data-testid={`c360-action-pend-${i}`}>
    <PendBadge status={p.status} />
    <span>Alertado por {p.sender_name} a {p.recipient_name} · {fmtDT(p.created_at)}</span>
    {['enviado', 'lido'].includes(p.status) && <Countdown deadline={p.deadline_at} />}
    {p.historico?.length > 1 && p.historico[p.historico.length - 1].note && (
      <span className="block w-full text-slate-700">Resposta: “{p.historico[p.historico.length - 1].note}”</span>
    )}
  </div>
);

const ActionRow = ({ a, i, onOpen, onAlert, manager }) => {
  const isMove = a.tipo === 'mudar';
  const Icon = isMove ? ArrowRightLeft : PhoneCall;
  const open = a.pendencia && OPEN.includes(a.pendencia.status);
  return (
    <div className="flex items-start gap-3 p-3 rounded-xl bg-white border border-rose-100 hover:border-rose-300 transition-colors" data-testid={`c360-action-${i}`}>
      <span className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${isMove ? 'bg-rose-600 text-white' : 'bg-amber-100 text-amber-700'}`}>
        <Icon className="w-4 h-4" />
      </span>
      <div className="flex-1 min-w-0">
        <button onClick={onOpen} className="text-left w-full" data-testid={`c360-action-open-${i}`}>
          <span className="block text-sm font-semibold text-slate-800">
            {isMove ? `${GRUPO[a.grupo]?.label || ''} · ${companyLabel(a.company)}` : 'Lead por tratar'}
          </span>
          <span className="block text-xs text-slate-600">{a.msg}{a.next_action_at ? ` · próxima ação ${fmtDT(a.next_action_at)}` : ''}</span>
        </button>
        {a.pendencia && <PendInfo p={a.pendencia} i={i} />}
      </div>
      {manager && !open && (
        <button onClick={onAlert} title="Alertar comercial" data-testid={`c360-action-alert-${i}`}
          className="shrink-0 inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-rose-600 text-white hover:bg-rose-700 transition-colors">
          <BellRing className="w-3.5 h-3.5" />Alertar
        </button>
      )}
      <ChevronRight className="w-4 h-4 text-slate-400 mt-2 shrink-0" />
    </div>
  );
};

export const NextActions = ({ acoes, cliente, onChanged }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [alertItem, setAlertItem] = useState(null);
  if (!acoes.length) {
    return (
      <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 flex items-center gap-3" data-testid="c360-actions-empty">
        <CheckCircle2 className="w-5 h-5 text-emerald-600" />
        <div className="text-sm text-emerald-900"><b>Nada a fazer agora.</b> O cliente está fidelizado e sem leads em aberto.</div>
      </div>
    );
  }
  const open = (a) => a.tipo === 'mudar'
    ? navigate(`/contracts/${a.category || 'luz_gas'}/${a.company}/${a.contract_id}`)
    : navigate(`/leads/${a.lead_id}`);
  return (
    <div className="rounded-2xl border border-rose-200 bg-rose-50/60 p-4 space-y-3" data-testid="c360-actions">
      <div>
        <h2 className="text-base md:text-lg font-bold font-[Outfit] text-rose-900">O que fazer agora ({acoes.length})</h2>
        <p className="text-xs text-rose-800/80">Energia: avisa quando a fidelização termina. Telecomunicações: avisa 60 dias antes.</p>
      </div>
      <div className="grid gap-2 md:grid-cols-2">
        {acoes.map((a, i) => (
          <ActionRow key={i} a={a} i={i} manager={isManager(user)} onOpen={() => open(a)}
            onAlert={() => setAlertItem({ ...a, nome: cliente.nome, comercial: a.comercial || cliente.comercial })} />
        ))}
      </div>
      <AlertComercialDialog open={!!alertItem} items={alertItem ? [alertItem] : []} onClose={() => setAlertItem(null)} onSent={onChanged} />
    </div>
  );
};
